import { render, staticRenderFns } from "./EmployeePowerOfAttorneyList.vue?vue&type=template&id=2cc5dac6&"
import script from "./EmployeePowerOfAttorneyList.vue?vue&type=script&lang=js&"
export * from "./EmployeePowerOfAttorneyList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePowerOfAttorneyList.vue?vue&type=style&index=0&id=2cc5dac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports